/**
 * Functions related to load more protfolio items functionality
 *
 * @param selectedElement
 * @param triggerElement
 * @param activeClass
 */

import {hide, show} from './helpers';

export const loadMorePortfolioItems = (triggerElement) => {
	let portfolioItemsLimit = 4;
	const triggerEl = triggerElement && document.querySelector(triggerElement);
	const portfolioItems = Array.from(document.querySelectorAll('.developer-portfolio-item'));
	const portfolioItemsLength = portfolioItems.length;

	// Hide load more button, if the items are less or equal to the limit
	if (portfolioItems.length <= portfolioItemsLimit) {
		triggerEl && hide(triggerEl);
	} else {
		// Hide all items after
		portfolioItems.forEach((item, index) => {
			if (index + 1 > portfolioItemsLimit) {
				hide(item);
			}
		});
	}

	function loadMore(el) {
		el.preventDefault();
		portfolioItemsLimit += portfolioItemsLimit; // Offset the portfolio items limit

		// Loop through  portfolio items, and show the ones that are less or equal to the "offseted" portfolio items limit
		portfolioItems.forEach((item, index) => {
			if (index + 1 <= portfolioItemsLimit) {
				show(item);
			}
		});

		// If the portfolio items limit "reaches" the portfolio items length, then hide the load more
		if (portfolioItemsLimit >= portfolioItemsLength) {
			hide(triggerEl);
		}
	}

	triggerEl && triggerEl.addEventListener('click', loadMore);
}
